import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';
import '../../sass/components/flexibleModules/_components.TabbedContentAppHub.scss';

const TabbedContentAppHub = ({ postObject, data }) => {

    return (
        <div class="cp-tabbedContentAppHub">
            <div className="cp-tabbedContentAppHub__inner">
                <div className="cp-tabbedContentAppHub__top l--flex">
                    <div className="cp-tabbedContentAppHub__top-left">
                        {data.additionalResourcesTabTitle &&
                            <h2>{data.additionalResourcesTabTitle}</h2>
                        }
                        {data.additionalResourcesTabContent &&
                            <div dangerouslySetInnerHTML={{ __html: data.additionalResourcesTabContent }} />
                        }
                    </div>
                    <div className="cp-tabbedContentAppHub__top-right">
                        {data.additionalResourcesRightSectionMainHeader &&
                            <h3>{data.additionalResourcesRightSectionMainHeader}</h3>
                        }
                        {data.additionalResourcesRightSectionMainLogo &&
                            <img loading="lazy" src={data.additionalResourcesRightSectionMainLogo.sourceUrl} alt={data.additionalResourcesRightSectionMainLogo.altText} />
                        }
                        {data.additionalResourcesRightSectionRepeater ?
                            <div className="l--topicsContent">
                                {data.additionalResourcesRightSectionRepeater.map((content, index) => (
                                    <div className="l--topicsContent__section" key={index}>
                                        {content.title &&
                                            <h4>{content.title}</h4>
                                        }
                                        {content.teaser &&
                                            <span dangerouslySetInnerHTML={{ __html: content.teaser }} />
                                        }
                                    </div>
                                ))}
                            </div>
                            :
                            <div className="l--topicsContent">
                                <div className="l--topicsContent__section">
                                    <h4>Author</h4>
                                    {postObject[0].node.apphubauthors &&
                                        <>
                                            {postObject[0].node.apphubauthors.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className="l--topicsContent__section">
                                    <h4>Industry</h4>
                                    {postObject[0].node.apphubindustries &&
                                        <>
                                            {postObject[0].node.apphubindustries.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className="l--topicsContent__section">
                                    <h4>Function</h4>
                                    {postObject[0].node.apphubfunctions &&
                                        <>
                                            {postObject[0].node.apphubfunctions.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                            </div>
                        }
                        {data.tabbedLayoutCheck === 'partner' &&
                            <div className="l--topicsContent">
                                <div className="l--topicsContent__section">
                                    <h4>Author</h4>
                                    {postObject[0].node.apphubauthors &&
                                        <>
                                            {postObject[0].node.apphubauthors.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className="l--topicsContent__section">
                                    <h4>Industry</h4>
                                    {postObject[0].node.apphubindustries &&
                                        <>
                                            {postObject[0].node.apphubindustries.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className="l--topicsContent__section">
                                    <h4>Function</h4>
                                    {postObject[0].node.apphubfunctions &&
                                        <>
                                            {postObject[0].node.apphubfunctions.nodes.map((fn, index) => (
                                                <span key={index} dangerouslySetInnerHTML={{ __html: fn.name }} />
                                            ))}
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="cp-tabbedContentAppHub__bottom">
                    {data.additionalResourcesRelatedResourcesTitle &&
                        <h2>{data.additionalResourcesRelatedResourcesTitle}</h2>
                    }
                    {data.additionalResourcesRelatedResources &&
                        <div className="cp-tabAdditionalresources">
                            {data.additionalResourcesRelatedResources.map((gridFields, index) => (
                                <React.Fragment key={index}>
                                    {gridFields.apphubPostFields.apphubLinkInternalOrExternal === 'internal' ?
                                        <Link to={`/solution-hub/${gridFields.slug}/`} className={`cp-apphubGridSections__section ${gridFields.apphubPostFields.apphubHeader.includes("overview") ? "l--overviewTile" : ""}`}>
                                            {gridFields.apphubPostFields.apphubIllustration ?
                                                <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                :
                                                <StaticImage src="../../images/apphub-illustration-placeholder-new.png" alt="Apphub" />
                                            }
                                            <div>
                                                {gridFields.apphubPostFields.apphubHeader &&
                                                    <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                }
                                                {gridFields.apphubPostFields.apphubTeaser &&
                                                    <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                }
                                                <span className="l--flex">
                                                    {process.env.GATSBY_LANG === "de" ?
                                                        <span>Lösung erkunden</span>
                                                        :
                                                        <span>Explore solution</span>
                                                    }
                                                    <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" />
                                                </span>
                                            </div>
                                        </Link>
                                        :
                                        <a href={gridFields.apphubPostFields.apphubExternalLink} target="_blank" className="cp-apphubGridSections__section">
                                            {gridFields.apphubPostFields.apphubIllustration ?
                                                <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                :
                                                <StaticImage src="../../images/apphub-illustration-placeholder.png" alt="Apphub" />
                                            }
                                            <div>
                                                {gridFields.apphubPostFields.apphubHeader &&
                                                    <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                }
                                                {gridFields.apphubPostFields.apphubTeaser &&
                                                    <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                }
                                                <span className="l--flex">
                                                    {process.env.GATSBY_LANG === "de" ?
                                                        <span>Lösung erkunden</span>
                                                        :
                                                        <span>Explore solution</span>
                                                    }
                                                    <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" />
                                                </span>
                                            </div>
                                        </a>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default TabbedContentAppHub;